import ItemCategory from '../../section/itemCategory';
import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { getBySlug } from '../../api/categoryChild';
import { Col, Row, Select, Button } from 'antd';
import { getAll } from '../../api/category';
import ItemProductGrid from '../../section/itemProductGrid';
import { useDevice } from '../../hooks';
import CategoryChildIsMobile from './categoryDetailIsMobile';

export default function CategoryChild() {
    const param = useParams();
    const { isMobile } = useDevice();
    const [categoryChild, setCategoryChild] = useState([]);
    const [isFixed, setIsFixed] = useState(false);
    const [topBuy, setTopBuy] = useState(false);
    const [price, setPrice] = useState(0);
    const [category, setCategory] = useState([]);
    const [itemsToShow, setItemsToShow] = useState(10);

    useEffect(() => {
        window.scrollTo(0, 0);
        let query = `page=1&pageSize=${itemsToShow}`;
        if (topBuy) { query += `&topBuy=1`; }
        if (price > 0) { query += `&filPrice=${price}`; }
        getBySlug(param.slug, query, setCategoryChild);
    }, [param?.slug, itemsToShow, topBuy, price]);

    useEffect(() => {
        getAll("page=1&pageSize=100", setCategory);
    }, []);
    
    useEffect(() => {
        const handleScroll = () => {
            setIsFixed(window.scrollY > 100);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const handleLoadMore = () => {
        setItemsToShow(prev => prev + 10);
    };

    return (
        <div className="max-w-screen-2xl mx-auto">
            {isMobile ? <CategoryChildIsMobile /> : (
                <Row>
                    <Col xs={24} xl={4} className='pr-2'> 
                        <div 
                            className="category-side-panel my-2 p-5 bg-white rounded-lg sticky self-start overflow-y-auto" 
                            style={{ scrollbarWidth: 'none' }}
                        >
                            {category?.data?.map((_, i) => (
                                <a key={i} href={`/danh-muc-san-pham/${_?.category_slug}`} className='flex items-center p-2 hover:bg-gray-200 rounded-xl'>
                                    <img src={_?.category_image} className='rounded-xl h-[40px] w-[40px]' />
                                    <p className='pl-2 text-black w-[150px]'>{_?.category_name}</p>
                                </a>
                            ))}
                        </div>
                    </Col>
                    <Col xs={24} xl={20}>
                        <div className='my-2 p-5 bg-white rounded-xl'>
                            <h1 className='text-[28px] font-semibold'>{categoryChild?.data?.category_child_name}</h1>
                        </div>
                        
                        <div className='my-2 p-5 bg-white rounded-xl'>
                            <div className='flex items-center'>
                                <p className='font-semibold'>Sắp xếp theo:</p>
                                <div className='px-2'>
                                    <button 
                                        className={`border px-4 py-1 mx-4 font-normal rounded-lg ${topBuy ? "bg-blue-500 text-white" : ""}`} 
                                        onClick={() => { setTopBuy(!topBuy); setPrice(0); }}
                                    >
                                        Bán Chạy
                                    </button>
                                    <Select
                                        className="w-[180px]"
                                        onChange={(e) => { setPrice(e); setTopBuy(false); }}
                                        options={[
                                            { label: "Giá", value: 0 },
                                            { label: "Giá: Từ thấp đến cao", value: 1 },
                                            { label: "Giá: Từ cao đến thấp", value: 2 }
                                        ]}
                                        value={price}
                                    />
                                </div>
                            </div>
                            <div className='pt-4 pb-10'>
                                <ItemProductGrid
                                    product={categoryChild?.data?.dataProduct?.slice(0, itemsToShow)} 
                                    grid={5} 
                                    titleSize={13}
                                    heightTitle={10}
                                />
                            </div>
                            {itemsToShow < categoryChild?.total && (
                               <button className='border px-4 py-2 font-semibold text-lg text-blue-600 border-blue-600 hover:bg-blue-100' onClick={handleLoadMore}>Xem thêm</button>
                            )}
                        </div>
                    </Col>
                </Row>
            )}
        </div>
    );
}